import { setupListeners } from '@reduxjs/toolkit/query';
import { applyMiddleware, compose, createStore, type Middleware, type StoreEnhancer } from 'redux';
import thunkMiddleware from 'redux-thunk';

import { observerApi } from './api/observerApi';
import monitorReducerEnhancer from './enhancers/monitorReducer';
import loggerMiddleware from './middleware/logger';
import reducers from './reducers/rootreducer';

export default function configureStore(preloadedState?: any) {
	// observerApi.middleware powers RTK Query caching, dedupe and (re)fetch for the
	// observer endpoints; it lives alongside the legacy thunk middleware.
	const middlewares: Middleware[] = [loggerMiddleware, thunkMiddleware, observerApi.middleware as Middleware];
	const middlewareEnhancer = applyMiddleware(...middlewares);

	const enhancers = [middlewareEnhancer, monitorReducerEnhancer];
	const composedEnhancers = compose(...enhancers);

	const store = createStore(reducers, preloadedState, composedEnhancers as StoreEnhancer<unknown>);

	// Enables refetchOnFocus / refetchOnReconnect behaviour for RTK Query.
	setupListeners(store.dispatch);

	// if (process.env.NODE_ENV !== 'production' && module.hot) {
	//     module?.hot?.accept('./reducers', () => store.replaceReducer(reducers));
	// }

	return store;
}
